import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRequest } from 'app/shared/Domains/request';
import { Configuration } from "config/config";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService,} from "primeng/api";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { IMember } from 'app/shared/Domains/member';
import { IMemberFreezeDetail } from 'app/shared/Domains/memberFreezeDetail';
import { ISettings } from "app/shared/Domains/settings";
import { IMemberEmergencyContact } from "app/shared/Domains/memberEmergencyContact";
import { Customerstrainer } from "app/shared/Domains/Customerstrainer";
import { ICompany } from "app/shared/Domains/company";
import { IAddress } from "app/shared/Domains/address";
import { IMemberContact } from "app/shared/Domains/memberContact";
import globalVariable from "../../../../globalVariable/globalVariable.json";
import { RequestStatus } from 'app/shared/enums/enums';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: 'app-member-request-detail',
    templateUrl: './member-request-detail.component.html',
    styleUrls: ['./member-request-detail.component.css']
})
export class MemberRequestDetailComponent implements OnInit {
    @Input() requestor;
    @Output("reject") reject: EventEmitter<any> = new EventEmitter();
    member: IMember;
    loading: boolean;
    user: IUser;
    freezeMemberDetails: any[];
    errorExempleNumber: any;
    company: ICompany;
    branch: IBranch;
    date: any;
    freezeDetail: IMemberFreezeDetail;
    requestId: string;
    RequestStatus = RequestStatus;
    message: string;
    isSuccess: boolean;
    isError: boolean;
    activeIndex: number;
    alreadyExistID: any;
    existIn: string;
    phoneNumber: string;
    formattedNumber : string = '';

    constructor(
        private LanguageService: LanguageService,
        private route: ActivatedRoute,
        public config: Configuration,
        private confirmationService: ConfirmationService,
        private ConfirmationService: ConfirmationService,
        private router: Router,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager
    ) {
        route.params.subscribe((params) => {
            this.requestId = params["id"];
            if (this.requestId !== undefined) {
                this.requestId = params["id"];
                this.getRequestByID();

            }
        });

    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("MemberRequestDetailComponent", label);
      }
    ngOnInit() {
        // this.requestor = new IRequest();
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;

        this.date = new Date();
        this.user = AuthService.getLoggedInUser();
        this.member = new IMember();
        this.company = new ICompany();
        this.branch = new IBranch();
        this.freezeDetail = new IMemberFreezeDetail();
        this.getFreezeReport();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail = new IMemberContact();
        this.member.contactDetail.contact = "";
        this.requestor.contactDetail = new IMemberContact();
        this.member.contactDetail.address = new IAddress();
        this.requestor.contactDetail.address = new IAddress();
        this.member.customerstrainer = new Customerstrainer();
        this.member.settings = new ISettings();
        this.getCompany();
        this.getBranch();
    }
    InitObjects() {
        this.requestor = new IRequest();
        this.member.settings = new ISettings();
    }
    getRequestByID() {
        this.loading = true;
        this.appServiceManager
            .get("customers/requests/" + this.requestId)
            .subscribe(
                (requestor: any) => {
                    this.requestor = requestor;
                    this.loading = false;
                    if(requestor.requestType == "Registration" && requestor.requestStatus !=="Approved"){
                    this.phoneNumber = requestor.contactDetail.contact;
                    }
                },
                (error) => {
                    this.loading = false;
                }
            );
    }

    checkMemberExistence(phoneNumber) {

        this.appServiceManager
            .get("customers/checkExistenceByPhone/" + phoneNumber + "?branch=" + this.branch._id)
            .subscribe(
                (response: any) => {
                    this.existIn= response.type;
                    if(this.existIn == "customer"){
                    this.alreadyExistID = response.id;
                    }else{
                    this.alreadyExistID  = [];
                    for(let i =0; i< response.data.length; i++){
                        if(response.data[i].requestId !== this.requestor.requestId && response.data[i].requestType == "Registration")
                        this.alreadyExistID.push({
                            requestId: response.data[i].requestId,
                            _id: response.data[i]._id
                        });
                    }
                    }

                    console.log("Member exists:", response);
                },
                (error) => {
                    console.error("Error checking member existence:", error);
                }
            );
    }

    redirectToMember(){
        this.router.navigateByUrl(
            "/members/member/" + this.alreadyExistID
        );
    }

    redirectToRequest(id){
        this.router.navigate(['request-detail', id], { relativeTo: this.route.parent });
    }
    update(requestorForm: any) {
        if (requestorForm.valid) {
        console.log(requestorForm.value);
        let payload = requestorForm.value || {}; // Initialize payload with the existing form value or an empty object
        const contact = this.requestor.contactDetail.contact;
        payload.contact = contact;
        if (!payload.hasOwnProperty('scope')) {
            payload.scope = 'Request'; 
        }
        if (!payload.hasOwnProperty('initiatedFrom')) {
            payload.initiatedFrom = 'Member Request Detail'; 
        }
        if (!payload.hasOwnProperty('activityBy')) {
            payload.activityBy = this.user.name; 
        }

        this.appServiceManager
            .put("requests/" + this.requestId, payload)
            .subscribe(
                (_res: any) => {
                    if (_res.status === true) {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "success",
                            summary: "Success Message",
                            detail: "Member Successfully Updated",
                        });
                    }
                },
                (error: any) => {
                    this.message = "Something went wrong ";
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
        }
        else {
            //  // Form validation error handling
            Object.keys(requestorForm.controls).forEach(controlName => {
                const control = requestorForm.controls[controlName];
                control.markAsTouched(); // Mark the control as touched to display the validation error messages
            });
        }
    }

    getCompany() {
        this.appServiceManager.get('companies/' + this.user.company).subscribe((res) => {
            if (res) {
                this.company = res;
            } else {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        },
            (error) => {
                this.company = new ICompany();
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
    }

    getBranch() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            this.checkMemberExistence(this.phoneNumber);   
        }
        if(!this.branch){
        this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
            if (res) {
                this.branch = res;
                this.checkMemberExistence(this.phoneNumber);
            } else {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        },
            (error) => {
                this.branch = new IBranch();
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
    }

    defreezeMember(member: IMember) {
        this.confirmationService.confirm({
            message: "Are you sure you want to DeFreeze member ?",
            accept: () => {
                this.loading = true;
                member.freezeDetail.isFreeze = false;
                var memberDueDate = new Date(member.settings.dueDate);
                var checkDay = memberDueDate.getDate();
                var checkMonth = memberDueDate.getMonth() + 1;
                var checkYear = memberDueDate.getFullYear();
                checkDay +=
                    parseInt(member.freezeDetail.daysLeft.toString()) - 1;
                if (checkDay > 30) {
                    checkDay -= 30;
                    checkMonth += 1;
                    var ActualDate =
                        checkMonth + "/" + checkDay + "/" + checkYear;
                    member.settings.dueDate = new Date(ActualDate);
                } else {
                    var ActualDate =
                        checkMonth + "/" + checkDay + "/" + checkYear;
                    member.settings.dueDate = new Date(ActualDate);
                }
                member.freezeDetail.daysLeft = 0;
                member.type = 'DeFreeze';
                member.scope = 'Member';
                member.initiatedFrom = 'Member Request detail';
                member.currentUserData = this.user;
                this.appServiceManager
                    .put("customers/defreeze/" + this.member._id, member)
                    .subscribe(
                        (res: any) => {
                            if (res.status === true) {
                                this.member = res.customer;
                                this.validateMember(this.member);
                                this.messageService.clear();
                                this.loading = false;
                                this.messageService.add({
                                    severity: "success",
                                    summary: "Success Message",
                                    detail: "Successfully Freezed",
                                });
                            } else {
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something Went Wrong",
                                });
                            }
                            this.getFreezeReport();
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "error",
                                summary: "Error Message",
                                detail: error,
                            });
                        }
                    );
            },
        });
    }

    getFreezeReport() {
        this.freezeMemberDetails = [];
        this.appServiceManager
            .get("customers/freezeMemberDetails/" + this.requestor.tagNumber)
            .subscribe(
                (res: any) => {
                    if (res) {
                        this.freezeMemberDetails = res;
                    } else {
                        this.messageService.clear();
                        this.messageService.add({
                            severity: "info",
                            summary: "Info Message",
                            detail: "Something Went Wrong",
                        });
                    }
                },
                (error) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );
    }

    validateMember(res) {
        if (
            this.member.settings === null ||
            this.member.settings === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (
            this.member.settings.dueDate === null ||
            this.member.settings.dueDate === undefined
        ) {
            this.member.settings = new ISettings();
            this.member.settings.dueDate = null;
        } else if (res.settings.dueDate === "null") {
            this.member.settings.dueDate = null;
        } else {
            var dueDate = JSON.stringify(res.settings.dueDate);
            var DD = JSON.parse(dueDate).split("/");
            if (DD.length === 1) {
                this.member.settings.dueDate = new Date(DD);
            } else {
                var newDDate = DD[1] + "/" + DD[0] + "/" + DD[2];
                if (newDDate) {
                    this.member.settings.dueDate = new Date(newDDate);
                }
            }
        }
        if (
            this.member.customerstrainer === undefined ||
            this.member.customerstrainer === null
        ) {
            this.member.customerstrainer = new Customerstrainer();
            this.member.customerstrainer.name = "";
            this.member.customerstrainer.trainerId = "";
            this.member.customerstrainer.totalFees = "";
        }
        if (
            this.member.emergencyContact === null ||
            this.member.emergencyContact === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        } else if (
            this.member.emergencyContact.medicalDetail === null ||
            this.member.emergencyContact.medicalDetail === undefined
        ) {
            this.member.emergencyContact = new IMemberEmergencyContact();
        }
        if (this.member.contactDetail.address) {
            if (
                this.member.contactDetail.address.street === null &&
                this.member.contactDetail.address.street === ""
            ) {
                this.member.contactDetail.address.street = "";
            }
            if (
                this.member.contactDetail.address.city === null &&
                this.member.contactDetail.address.city === ""
            ) {
                this.member.contactDetail.address.city = "";
            }
            if (
                this.member.contactDetail.address.country === null &&
                this.member.contactDetail.address.country === ""
            ) {
                this.member.contactDetail.address.country = "";
            }
            if (
                this.member.contactDetail.address.state === null &&
                this.member.contactDetail.address.state === ""
            ) {
                this.member.contactDetail.address.state = "";
            }
            if (
                this.member.contactDetail.address.zipCode === null &&
                this.member.contactDetail.address.zipCode === ""
            ) {
                this.member.contactDetail.address.zipCode = "";
            }
            if (
                this.member.contactDetail.address.town === null &&
                this.member.contactDetail.address.town === ""
            ) {
                this.member.contactDetail.address.town = "";
            }
        } else {
            this.member.contactDetail.address = new IAddress();
        }
    }
    // <title style=" margin-top:500px">Registration Request Details</title>
    printRequestDetail(): void {
        let printContents: string, popupWin: Window;
        printContents = document.getElementById('requestDetailsForPrint').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
        <html>
        <head>

            <style>
                .invoice-box {
                    max-width: 800px;
                    margin-bottom:auto;
                    margin-top:11rem;
                    margin-right:auto;
                    margin-left:auto;
                    padding: 30px;
                    border: 1px solid #eee;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                    font-size: 16px;
                    line-height: 24px;
                    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                    color: #555;
                }

                .invoice-box table {
                    width: 100%;
                    line-height: inherit;
                    text-align: left;
                }

                .invoice-box table td {
                    padding: 5px;
                    vertical-align: top;
                }

                .invoice-box table tr td:nth-child(n + 2) {
                    text-align: left;

                }

                .invoice-box table tr.top table td {
                    padding-bottom: 20px;

                }

                .invoice-box table tr.top table td.title {
                    font-size: 45px;
                    line-height: 45px;
                    color: #333;

                }

                .invoice-box table tr.information table td {
                    padding-bottom: 40px;
                }

                .invoice-box table tr.heading td {
                    background: #eee;
                    border-bottom: 1px solid #ddd;
                    font-weight: bold;
                }

                .invoice-box table tr.details td {
                    padding-bottom: 20px;
                }

                .invoice-box table tr.item td {
                    border-bottom: 1px solid #eee;
                }
                .invoice-box table tr.item.last td {
                    border-bottom: none;
                }
                .invoice-box table tr.item input {
                    padding-left: 5px;
                }
                .invoice-box table tr.item td:first-child input {
                    margin-left: -5px;
                    width: 100%;
                }
                .invoice-box table tr.total td:nth-child(2) {
                    border-top: 2px solid #eee;
                    font-weight: bold;
                }
                .invoice-box input[type="number"] {
                    width: 60px;
                }
                @media only screen and (max-width: 600px) {
                    .invoice-box table tr.top table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }

                    .invoice-box table tr.information table td {
                        width: 100%;
                        display: block;
                        text-align: center;

                    }
                }
                .rtl {
                    direction: rtl;
                    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                        sans-serif;
                }
                .rtl table {
                    text-align: right;
                }
                .rtl table tr td:nth-child(2) {
                    text-align: left;
                }
            </style>
        </head>
        <body>${printContents}</body>
        </html>
        `
        );
    }
    getHtml() {
        let printContents: string;
        printContents = document.getElementById('allEnquiries').innerHTML;

        let htmlToPdf = `<html>
        <head>
            <title>Gym Invoice</title>
            <style>
                .invoice-box {
                    max-width: 800px;
                    margin: auto;
                    padding: 30px;
                    border: 1px solid #eee;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                    font-size: 16px;
                    line-height: 24px;
                    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                    color: #555;
                }

                .invoice-box table {
                    width: 100%;
                    line-height: inherit;
                    text-align: left;
                }

                .invoice-box table td {
                    padding: 5px;
                    vertical-align: top;

                }

                .invoice-box table tr td:nth-child(n + 2) {
                    text-align: right;
                }

                .invoice-box table tr.top table td {
                    padding-bottom: 20px;
                }

                .invoice-box table tr.top table td.title {
                    font-size: 45px;
                    line-height: 45px;
                    color: #333;
                }

                .invoice-box table tr.information table td {
                    padding-bottom: 40px;
                }

                .invoice-box table tr.heading td {
                    background: #eee;
                    border-bottom: 1px solid #ddd;
                    font-weight: bold;
                }

                .invoice-box table tr.details td {
                    padding-bottom: 20px;

                }

                .invoice-box table tr.item td {
                    border-bottom: 1px solid #eee;
                }
                .invoice-box table tr.item.last td {
                    border-bottom: none;
                }
                .invoice-box table tr.item input {
                    padding-left: 5px;
                }
                .invoice-box table tr.item td:first-child input {
                    margin-left: -5px;
                    width: 100%;
                }
                .invoice-box table tr.total td:nth-child(2) {
                    border-top: 2px solid #eee;
                    font-weight: bold;
                }
                .invoice-box input[type="number"] {
                    width: 60px;

                }
                @media only screen and (max-width: 600px) {
                    .invoice-box table tr.top table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }

                    .invoice-box table tr.information table td {
                        width: 100%;
                        display: block;
                        text-align: center;
                    }
                }
                .rtl {
                    direction: rtl;
                    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                        sans-serif;
                }
                .rtl table {
                    text-align: right;
                }
                .rtl table tr td:nth-child(2) {
                    text-align: left;
                }
            </style>
        </head>
        <body>${printContents}</body>
        </html>`

        return htmlToPdf;
    }
    rejectRequest() {
        this.reject.emit();
    }
    approved() {
        this.member = Object.assign(this.member, this.requestor);
        this.member.joiningDate = new Date();
        // this.setMemberData(this.member);
        this.ConfirmationService.confirm({
            message: "Are you sure you want to approved request ?",
            accept: () => {
                this.loading = true;
                if (!this.member.hasOwnProperty('scope')) {
                    this.member.scope = 'Request'; 
                }
                if (!this.member.hasOwnProperty('type')) {
                    this.member.type = 'Approve Member Request'; 
                }
                if (!this.member.hasOwnProperty('initiatedFrom')) {
                    this.member.initiatedFrom = 'Member Request Detail'; 
                }
                if (!this.member.hasOwnProperty('createdBy')) {
                    this.member.createdBy = this.user.name; 
                }
                this.appServiceManager
                    .post("customers/approveRegistration", this.member)
                    .subscribe(
                        (member) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Member Registration Approved Successfully",
                            });
                            setTimeout(() => {
                                this.router.navigateByUrl(
                                    "/members/member/" + member._id
                                );
                            }, 300);
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "info",
                                summary: "Info Message",
                                detail: "Something Went Wrong",
                            });
                        }
                    );
            },
        });
    }

    proceedForApproval(form:any) {
        if (form.valid) {
        this.router.navigateByUrl('/members/member?requestid=' + this.requestId)
    }
    else {
        //  // Form validation error handling
        Object.keys(form.controls).forEach(controlName => {
            const control = form.controls[controlName];
            control.markAsTouched(); // Mark the control as touched to display the validation error messages
        });
    }
    }


}
function updateRequestDetail() {
    throw new Error('Function not implemented.');
}

